import { sortBy, toNumber } from 'lodash-es';
import type { CiteKnowledge, SourceKnowledge } from 'services/api/supplementKnowledge';
import { isSameKnowledge, resolveKnowledgeType } from './knowledgeType';

export const isPlatformProductCitation = (knowledge: CiteKnowledge) =>
  knowledge.citationSource === 'PRODUCT_TITLE' ||
  knowledge.citationSource === 'PRODUCT_DESCRIPTION';

export const transformKnowledge = (
  citeKnowledge: CiteKnowledge[],
  sourceKnowledge: SourceKnowledge[],
) => {
  return sortBy(
    citeKnowledge.reduce(
      (res, knowledge) => {
        // 平台原始信息只展示统一提示，不进入本地知识的编辑和保存链路。
        if (isPlatformProductCitation(knowledge)) return res;
        let target = sourceKnowledge.find((source) => isSameKnowledge(source, knowledge));
        if (
          resolveKnowledgeType(knowledge) === 'product_detail_knowledge' &&
          knowledge.source === '商品详情页'
        ) {
          const sourceTarget = sourceKnowledge.find(
            (source) =>
              resolveKnowledgeType(source) === 'product_detail_knowledge' &&
              source.sourceId != null &&
              `${source.sourceId}` === `${knowledge.knowledgeId}`,
          );
          if (sourceTarget) {
            target = sourceTarget;
          }
        }
        if (!target || (String(knowledge.knowledgeId).startsWith('test') && !target.kvId)) {
          return res;
        }
        res.push({
          citeKnowledge: knowledge,
          sourceKnowledge: target,
        });
        return res;
      },
      [] as {
        citeKnowledge: CiteKnowledge;
        sourceKnowledge: SourceKnowledge;
      }[],
    ),
    ({ citeKnowledge }) => -toNumber(citeKnowledge.score),
  );
};
